import hyLocale from 'date-fns/locale/hy';
import enLocale from 'date-fns/locale/en-US';
import i18n from 'i18next';
import { isEmpty } from 'lodash';
import { LANGUAGES } from '../constants';

export const getFullNameByLang = (data, language) => {
  if (!Object.keys(data).length) return null;
  const result = language === LANGUAGES.HY
    ? `${data.firstName} ${data.lastName}`
    : `${data.firstNameEn} ${data.lastNameEn}`;

  return result.trim().length ? result : null;
};

export default getFullNameByLang;

export const getActiveLocale = () => {
  switch (localStorage.getItem('i18nextLng')) {
    case LANGUAGES.EN:
      return enLocale;
    default:
      return hyLocale;
  }
};

export const isArmenianLanguage = (language) => language === LANGUAGES.HY;

export const getClaimStatusTranslation = (claim, key) => {
  if (!claim) {
    return '';
  }

  if (i18n.language === LANGUAGES.EN) {
    return !isEmpty(claim[`${key}EN`]) ? claim[`${key}EN`] : '';
  }
  return claim[key];
};
